<template>
  <div :class="['mt-3', 'small-text', {'d-none': hideDisclaimer}]">
    <div v-html="disclaimerHtml" />
  </div>
</template>

<script>
export default {
  computed: {
    disclaimerHtml() {
      switch (this.agraConfiguration.botProtection.kind) {
      case 'hcaptcha':
        return this.i18n.t('public.hcaptcha.disclaimer_html')
      case 'recaptcha':
        return this.i18n.t('layouts.recaptcha_disclaimer_html')
      case 'turnstile':
        return this.i18n.t('public.turnstile.disclaimer_html')
      case 'friendly-captcha':  // Don't display a disclaimer for Friendly Captcha
        return null
      default:
        return null
      }
    },

    hideDisclaimer() {
      return this.disclaimerHtml === null
    }
  }
}
</script>
